import React, { useEffect } from 'react';
import { Hero } from './components/sections/Hero';
import { EmotionalHook } from './components/sections/EmotionalHook';
import { Problem } from './components/sections/Problem';
import { Solution } from './components/sections/Solution';
import { Benefits } from './components/sections/Benefits';
import { WhatsIncluded } from './components/sections/WhatsIncluded';
import { Difference } from './components/sections/Difference';
import { WhoItsFor } from './components/sections/WhoItsFor';
import { DirectMessage } from './components/sections/DirectMessage';
import { FinalCTA } from './components/sections/FinalCTA';
import { SocialProofPopup } from './components/ui/SocialProofPopup';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-[#FAF8F5] overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <EmotionalHook data-id="element-2" />
      <Problem data-id="element-3" />
      <Solution data-id="element-4" />
      <Benefits data-id="element-5" />
      <WhatsIncluded data-id="element-6" />
      <Difference data-id="element-7" />
      <WhoItsFor data-id="element-8" />
      <DirectMessage data-id="element-9" />
      <FinalCTA data-id="element-10" />

      <footer className="py-8 text-center text-[#8D8A86] text-sm bg-[#2D2A26]" data-id="element-11">
        <div className="max-w-2xl mx-auto px-6 space-y-6" data-id="element-12">
          <p data-id="element-13">© 2026 Todos los derechos reservados.</p>

          <p className="text-[#7D7A76] text-xs leading-relaxed text-left" data-id="element-14">
            Descargo de responsabilidad: Este producto no sustituye el consejo
            médico profesional. Si tienes problemas de salud crónicos, consulta
            a tu médico antes de realizar cambios en tu dieta o rutina. Los
            resultados pueden variar de una persona a otra.
          </p>

          <div className="flex items-center justify-start gap-6 text-[#8D8A86]" data-id="element-15">
            <a href="#" className="hover:text-[#E5E0D8] transition-colors" data-id="element-16">
              Privacidad
            </a>
            <a href="#" className="hover:text-[#E5E0D8] transition-colors" data-id="element-17">
              Términos
            </a>
            <a href="#" className="hover:text-[#E5E0D8] transition-colors" data-id="element-18">
              Contacto
            </a>
          </div>
        </div>
      </footer>

      <SocialProofPopup data-id="element-19" />
    </main>;
}